import { IAbmBuscador } from './../../../interfaces/pages/abm/abm-buscador.interface';
import { ResultsTable } from "./../../../components/shared/home-searcher/data-table/ResultsTable";
import { Row } from "./../../../components/shared/home-searcher/data-table/Row";
import { Persona } from "src/app/entities/shared/Persona";
import { Country } from "./../../../entities/shared/Country";
import { Injectable } from "@angular/core";
import { LocalStorageService } from "../local-storage/local-storage.service";

@Injectable({
  providedIn: "root",
})
export class HandleProfileService {
  constructor(private localStorageService: LocalStorageService) { }

  get countrySelected(): Country {
    return this.localStorageService.getRegionSeleccionada;
  }

  get buscadorSelect(): IAbmBuscador {
    return this.localStorageService.getBuscadorSelect;
  }

  handleObtenerPersonas(
    personasRes: any,
    idNumber: any,
    typePerOrEmp: string = null,
    fieldDniSearch?
  ) {
    // console.log('handleObtenerPersonas');
    // console.log('personasRes', personasRes);
    // Casuistica buscador, para merge trae data typePerOrEmp
    if (typePerOrEmp === null) {
      const { domain, subDomain } = this.buscadorSelect;
      typePerOrEmp = this.countrySelected.getUrlFindFull().find((profile) => (profile.subDomain === subDomain && profile.domain === domain))?.type || 'person';
    }
    // console.log("typePerOrEmp --->", typePerOrEmp);
    let persons;
    let personasAdd;
    let personasOld;
    let fieldDni = fieldDniSearch ? fieldDniSearch : (this.localStorageService.getBuscadorSelect?.fieldDni || '');
    if (["kl", "gkl"].includes(this.countrySelected.getService())) {
      // es enlace KL, Crea objeto TklHash a partir de uno KL
      persons = personasRes.map((per) => {
        const entityType = per.entityType === "Consumer" ? "F" : "J";

        // console.log('per[this.localStorageService.getBuscadorSelect.fieldDni]');
        // console.log('this.localStorageService.getBuscadorSelect ---->', this.localStorageService.getBuscadorSelect);

        // console.log('per[this.localStorageService.getBuscadorSelect.fieldDni]', per[fieldDni]);
        let cedulaDocumentoDni = per.identificador || per.documento || per.documento_numero || per.documentNum || per.ppu || per.rol || per.documentTypeNum;
        return {
          ...per,
          dniDoc: per[fieldDni],
          iup: Number(per.iup),
          entityKey: per.entityKey,
          rut: cedulaDocumentoDni,
          cedula: cedulaDocumentoDni,
          nationalId: cedulaDocumentoDni,
          patente: null,
          rutHash: per.entityKey,
          cedulaHash: per.entityKey,
          nationalIdHash: per.entityKey,
          patenteHash: per.entityKey,
          hash: per.entityKey,
          personaHash: per.entityKey,
          documentos: [
            {
              numero: idNumber,
              // tipo: this.countrySelected.getIdTextPerson(),
              version: "1",
            },
          ],
          tipoPersona: entityType,
          nombres: per.denominacion,
          apellidos: per.denominacion,
          denominacion: per.razonSocial ? per.razonSocial : per.denominacion,
          sexo: per.sexo,
          nacimientoFh: per.nacimiento,
          nacimientoAnio: per.nacimiento,
          celulares: [],
          fallecido: per.fallecido,
          emails: [],
          idsDigitales: [],
          validado: null,
          validadoFh: null,
          validadoFuente: null,
          score: null,
          acciones: [],
          bloqueos: [],
          baja: per.baja,
          tipoSocietario: null,
          perOrEmp: typePerOrEmp,
        };
      });
      personasOld = {
        persons,
      };
      return this.handlePersonas(personasOld, typePerOrEmp);

    } else if (["tkl", "hash"].includes(this.countrySelected.getService())) {
      persons = personasRes.map((per) => {
        per.perOrEmp = typePerOrEmp;
        let cedulaDocumentoDni = per.rut || per.cedula || per.nationalId;
        // console.log('per[this.localStorageService.getBuscadorSelect.fieldDni]2');
        return {
          ...per,
          dniDoc: per[fieldDni],
          iup: per.iup, // new
          entityKey: per.entityKey, // new
          rut: cedulaDocumentoDni,
          cedula: cedulaDocumentoDni, // new
          nationalId: cedulaDocumentoDni, // new
          patente: per.patente, // new
          rutHash: per.rutHash,
          cedulaHash: per.cedulaHash, // new
          nationalIdHash: per.nationalIdHash, // new
          patenteHash: per.patenteHash, // new
          hash: per.hash,
          personaHash: per.personaHash,
          documentos: per.documentos,
          tipoPersona: per.tipoPersona,
          nombres: per.nombres,
          apellidos: per.apellidos,
          denominacion: per.denominacion,
          sexo: per.sexo,
          nacimientoFh: per.nacimientoFh,
          nacimientoAnio: per.nacimientoAnio,
          celulares: per.celulares,
          fallecido: per.fallecido,
          emails: per.emails,
          idsDigitales: per.idsDigitales,
          validado: per.validado,
          validadoFh: per.validadoFh, // new
          validadoFuente: per.validadoFuente, // new
          score: per.score,
          acciones: per.acciones,
          bloqueos: per.bloqueos,
          baja: per.baja, // new
          tipoSocietario: per.tipoSocietario, // new
          perOrEmp: typePerOrEmp, // new
        };
      });
      personasAdd = {
        persons,
      };
      return this.handlePersonas(personasAdd, typePerOrEmp);
    }
  }

  handlePersonas(personasRes: { persons: any }, typePerOrEmp: string): ResultsTable {
    if (personasRes != undefined && personasRes?.persons.length == 0) {
      // TODO: Retornar null para saber que fallo
      // TODO: metodo fallo en home-searcher
      // this.showResultsMessage("No se encontraron resultados.");
      return null;
    } else {
      return this.buildTable(personasRes.persons, typePerOrEmp);
    }
  }

  buildTable(personas: Array<Persona>, perOrEmp: string): ResultsTable {
    // console.log('buildTable', personas);

    let rows = new Array<Row>();
    for (let person of personas) {
      let row = new Row(person);
      rows.push(row);
    }
    // console.log(
    //   "getTable",
    //   this.countrySelected.getTableConfiguration()
    // );
    // console.log("rows", rows);

    // TODO: Este es el return del metodo desde el servicio
    return new ResultsTable(
      this.countrySelected.getTableConfiguration(),
      rows
    );
  }

}
